import { render } from "./DeleteMemberModal.vue?vue&type=template&id=6c9ccd51&scoped=true"
import script from "./DeleteMemberModal.vue?vue&type=script&lang=js"
export * from "./DeleteMemberModal.vue?vue&type=script&lang=js"

import "./DeleteMemberModal.vue?vue&type=style&index=0&id=6c9ccd51&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9ccd51"]])

export default __exports__